__turbopack_context__.v({
  "container": "KpKfMG_container",
  "loader": "KpKfMG_loader",
  "message": "KpKfMG_message",
  "overlay": "KpKfMG_overlay",
  "spin": "KpKfMG_spin",
  "spinner": "KpKfMG_spinner",
});
